var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnnouncementIcon = function SvgAnnouncementIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66667 0H15C15.9167 0 16.6667 0.75 16.6667 1.66667V11.6667C16.6667 12.5833 15.9167 13.3333 15 13.3333H3.33333L0 16.6667V1.66667C0 0.75 0.75 0 1.66667 0ZM8.00002 3.7C8.46947 3.7 8.85002 3.31944 8.85002 2.85C8.85002 2.38056 8.46947 2 8.00002 2C7.53058 2 7.15002 2.38056 7.15002 2.85C7.15002 3.31944 7.53058 3.7 8.00002 3.7ZM7.39898 4.88129C7.55839 4.71719 7.77459 4.625 8.00002 4.625C8.22546 4.625 8.44166 4.71719 8.60106 4.88129C8.76047 5.04538 8.85002 5.26794 8.85002 5.5V9.875C8.85002 10.1071 8.76047 10.3296 8.60106 10.4937C8.44166 10.6578 8.22546 10.75 8.00002 10.75C7.77459 10.75 7.55839 10.6578 7.39898 10.4937C7.23958 10.3296 7.15002 10.1071 7.15002 9.875V5.5C7.15002 5.26794 7.23958 5.04538 7.39898 4.88129Z",
    fill: "#FB7D08"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnnouncementIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "announcement-icon.f79b0d057df22bae497f46bcaafd250d.svg";